export default {
  title: 'Junte-se a {{name}}!',
  default_program_name: 'Clube de Recompensas',
  benefits: {
    earn_points: 'Ganhe pontos com cada pedido',
    get_deals: 'Receba descontos exclusivos',
    redeem_points: 'Troque pontos por comida grátis',
  },
  terms: 'Ao registar-se, receberá ofertas por email e SMS do nosso&nbsp;',
  buttons: {
    log_in: 'Iniciar sessão',
    sign_up: 'Registar',
  },
  labels: {
    already_have_account: 'Já tem uma conta?',
  },
  signup_note:
    'Ao registar-se, receberá ofertas por email e SMS do nosso <0>restaurante</0> e da <1>FoodAmigos</1>, nosso parceiro tecnológico. Concorda com os nossos <2>Termos da Plataforma</2> e <3>Política de Privacidade</3>.',
};
